import { render } from "./DataPolicy.vue?vue&type=template&id=130ef528&scoped=true"
import script from "./DataPolicy.vue?vue&type=script&lang=js"
export * from "./DataPolicy.vue?vue&type=script&lang=js"

import "./DataPolicy.vue?vue&type=style&index=0&id=130ef528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130ef528"]])

export default __exports__